<p-floatLabel>
    <p-datepicker id="date" [showIcon]="true" class="calender-icon" [(ngModel)]="selectedScheduledDate" 
    (ngModelChange)="onScheduledDateChange($event)"
    class="w-64"
    (onSelect)="onScheduledDateChange($event)" inputId="icon">
    </p-datepicker>
    <label for="date"> {{inputlabel}} </label>
</p-floatLabel>